define('../app/fukit/view/block/two.column.content.header.view',['require','exports','module','underscore','uikit/uikit','../../helpers/extend.util'],function(require, exports, module) {
  //prettier-ignore
  var _          = require('underscore'),
      UIKit      = require('uikit/uikit'),
      ExtendUtil = require('../../helpers/extend.util');

  var HeaderComponentContainerView = UIKit.ComponentsContainerView.extend({
    className: 'actions container',

    onAddChild: function(child) {
      child.$el.css({
        display: 'inline-block',
        'margin-right': '0.3em',
      });
    },
  });

  var TwoColumnContentHeaderView = UIKit.ItemView.extend({
    className: 'ui segment blue content header',

    template: function() {
      return '<div class="ui grid"><div class="column eight wide"><ui name="leftColumnView" /></div> <div class="column eight wide right aligned"><ui name="rightColumnView" /></div></div>';
    },

    options: {
      attached: false,
      color: 'blue',
      padded: false,
    },

    internalViewOptions: {
      leftColumnView: ExtendUtil.extendOptionValueWithDefaults('leftColumnView', {
        type: HeaderComponentContainerView,
      }),
      rightColumnView: ExtendUtil.extendOptionValueWithDefaults('rightColumnView', {
        type: HeaderComponentContainerView,
      }),
    },

    updateAttributes: function() {
      var attached = this.getOption('attached');
      this.addClass((_.isString(attached) ? attached + ' ' : '') + 'attached', this.getBoolOption('attached'));
      this.addClass(this.getOption('color'), this.getBoolOption('color')),
        this.addClass('padded', this.getBoolOption('padded'));
    },
  });

  module.exports = TwoColumnContentHeaderView;
});

